/* eslint-disable @typescript-eslint/no-restricted-imports */
import { useSelector } from "react-redux";
import { getInstanceId } from "ee/selectors/tenantSelectors";
import { CUSTOMER_PORTAL_URL_WITH_PARAMS } from "constants/ThirdPartyConstants";
import type { EventName } from "ee/utils/analyticsUtilTypes";
import AnalyticsUtil from "utils/AnalyticsUtil";
import { getAppsmithConfigs } from "ee/configs";
import { pricingPageUrlSource } from "ee/utils/licenseHelpers";
import { BUSINESS_PRICE_URL } from "ee/constants/messages";
import type {
  RampFeature,
  RampSection,
} from "utils/ProductRamps/RampsControlList";

interface Props {
  logEventName?: EventName;
  logEventData?: any;
  featureName?: RampFeature;
  sectionName?: RampSection;
  intercomMessage?: string;
}

const useOnUpgrade = (props: Props) => {
  const { featureName, logEventData, logEventName, sectionName } = props;
  const instanceId = useSelector(getInstanceId);
  const appsmithConfigs = getAppsmithConfigs();

  const onUpgrade = () => {
    AnalyticsUtil.logEvent(
      logEventName || "ADMIN_SETTINGS_UPGRADE",
      logEventData,
    );
    window.open(BUSINESS_PRICE_URL, "_blank");
  };

  return { onUpgrade };
};

export default useOnUpgrade;
